<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-08 18:10:51
 * @FilePath: 
 * @Description: 点餐支付完成后页面
-->
<template>
  <div class="full_page">
    <div class="pay_result_con van-hairline--bottom">
      <img
        :src="
          orderInfo.status == 0
            ? require('@/assets/images/pay_failed.png')
            : require('@/assets/images/paySuccess.png')
        "
        alt=""
      />
      <p>{{ orderInfo.statusText }}</p>
      <p v-if="orderInfo.status != 0" class="c-orange">
        实付 ￥{{ orderInfo.price }}
      </p>
    </div>
    <van-cell
      v-if="orderInfo.status != 0"
      title="支付方式"
      :value="orderInfo.payType"
    />
    <div class="m-t-80 f-ar p-lr-30">
      <van-button color="#333" block plain @click="handleToHome"
        >返回首页</van-button
      >
      <span style="width: 20px"></span>
      <van-button color="#333" block @click="handleViewOrder"
        >查看订单</van-button
      >
    </div>
  </div>
</template>

<script>
import { getGoodOrderDetail } from "@/api/order";
import { handleLocalStorage, handleSessionStorage } from "@/utils";
export default {
  name: "payResult",
  props: {},
  data() {
    return {
      orderInfo: {},
    };
  },
  components: {},
  created() {
    this.orderId = handleLocalStorage.get("orderId");
    this.handleGetFoodInfo();
  },
  mounted() {},
  methods: {
    async handleGetFoodInfo() {
      const orderRes = await getGoodOrderDetail({ id: this.orderId });
      let statusText = "";
      if (orderRes.Status == 0) {
        statusText = "支付失败";
      } else {
        statusText = "支付成功";
      }
      this.orderInfo = {
        payType: orderRes.PayType,
        price: orderRes.Details[0].SettlePrice,
        status: orderRes.Status,
        statusText: statusText,
      };
      this.vpnSaaSCode = orderRes.SaasVpnCode;
      const vpnInfo = {
        // name: item.Name,
        code: orderRes.SaasVpnCode,
        id: orderRes.VpnId,
        // payAfterMeal: item.SaasVpnSetting.PayAfterMeal,
        // wechatPayChannel: item.SaasVpnSetting.WechatPayChannel,
      };
      handleSessionStorage.set("vpnInfo", vpnInfo);
      handleSessionStorage.set("deskCode", {
        code: orderRes.TableCode,
        depart: orderRes.SaasDepartId,
        checkinId: orderRes.CheckinId,
        cardCode: orderRes.KeyCode,
      });
    },
    handleToHome() {
      this.$router.push({
        name: "NewMicropoint",
        query: { saasCode: this.vpnSaaSCode },
      });
    },
    handleViewOrder() {
      this.$router.push({
        name: "MicropointHistoryConsume",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.pay_result_con {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  background: #fff;
  img {
    width: 100px;
    margin: 30px 0;
  }
  p {
    margin-bottom: 20px;
    font-size: 34px;
    &:last-child {
      font-size: 28px;
    }
  }
}
</style>
